module.exports = __webpack_public_path__ + "img/allgame.f03b78ca.png";